import { LayoutProps } from "../types"

export const RegionLayout = ({
  Header,
  Body,
  className,
  ...props
}: LayoutProps) => (
  <div
    className={`relative flex h-full w-full flex-col ${className ?? ""}`}
    role="region"
    aria-labelledby={props["aria-labelledby"]}
  >
    {Header}
    <div
      className="flex flex-1 flex-col overflow-y-auto bg-primary_alt"
      {...props}
    >
      {Body}
    </div>
  </div>
)
